const colors = {
  background: {
    default: "#FDF8F3",
  },

  text: {
    main: "#000000",
    focus: "#000000",
  },

  transparent: {
    main: "transparent",
  },

  white: {
    main: "#ffffff",
    focus: "#ffffff",
  },

  black: {
    light: "#000000",
    main: "#000000",
    focus: "#000000",
  },

  primary: {
    main: "#820000",
    focus: "#560000",
  },

  secondary: {
    main: "#C89B3C",
    focus: "#A97F27",
  },

  info: {
    main: "#1A73E8",
    focus: "#1662C4",
  },

  success: {
    main: "#4CAF50",
    focus: "#67bb6a",
  },

  warning: {
    main: "#fb8c00",
    focus: "#fc9d26",
  },

  // Kept clearly different from the maroon primary
  error: {
    main: "#E53935",
    focus: "#C62828",
  },

  light: {
    main: "#FDF5F0",
    focus: "#FBF3EC",
  },

  // Dark maroon (sidenav, headings that use color="dark")
  dark: {
    main: "#560000",
    focus: "#3D0000",
  },

  grey: {
    100: "#f8f9fa",
    200: "#f0f2f5",
    300: "#dee2e6",
    400: "#ced4da",
    500: "#adb5bd",
    600: "#6c757d",
    700: "#495057",
    800: "#343a40",
    900: "#212529",
  },

  gradients: {
    primary: {
      main: "#820000",
      state: "#560000",
    },

    secondary: {
      main: "#D8AE55",
      state: "#C89B3C",
    },

    info: {
      main: "#49a3f1",
      state: "#1A73E8",
    },

    success: {
      main: "#66BB6A",
      state: "#43A047",
    },

    warning: {
      main: "#FFA726",
      state: "#FB8C00",
    },

    error: {
      main: "#EF5350",
      state: "#E53935",
    },

    light: {
      main: "#FDF5F0",
      state: "#FBF3EC",
    },

    // Sidenav background
    dark: {
      main: "#820000",
      state: "#560000",
    },
  },

  socialMediaColors: {
    facebook: {
      main: "#3b5998",
      dark: "#344e86",
    },

    twitter: {
      main: "#55acee",
      dark: "#3ea1ec",
    },

    instagram: {
      main: "#125688",
      dark: "#0e456d",
    },

    linkedin: {
      main: "#0077b5",
      dark: "#00669c",
    },

    pinterest: {
      main: "#cc2127",
      dark: "#b21d22",
    },

    youtube: {
      main: "#e52d27",
      dark: "#d41f1a",
    },

    vimeo: {
      main: "#1ab7ea",
      dark: "#13a3d2",
    },

    slack: {
      main: "#3aaf85",
      dark: "#329874",
    },

    dribbble: {
      main: "#ea4c89",
      dark: "#e73177",
    },

    github: {
      main: "#24292e",
      dark: "#171a1d",
    },

    reddit: {
      main: "#ff4500",
      dark: "#e03d00",
    },

    tumblr: {
      main: "#35465c",
      dark: "#2a3749",
    },
  },

  badgeColors: {
    primary: {
      background: "#E8BDBD",
      text: "#6B0000",
    },

    secondary: {
      background: "#F2E2BC",
      text: "#7A5A12",
    },

    info: {
      background: "#aecef7",
      text: "#095bc6",
    },

    success: {
      background: "#bce2be",
      text: "#339537",
    },

    warning: {
      background: "#ffd59f",
      text: "#c87000",
    },

    error: {
      background: "#fcd3d0",
      text: "#f61200",
    },

    light: {
      background: "#ffffff",
      text: "#c7d3de",
    },

    dark: {
      background: "#C9A0A0",
      text: "#3D0000",
    },
  },

  coloredShadows: {
    primary: "#820000",
    secondary: "#C89B3C",
    info: "#00bbd4",
    success: "#4caf4f",
    warning: "#ff9900",
    error: "#e53935",
    light: "#adb5bd",
    dark: "#560000",
  },

  inputBorderColor: "#E2D5C8",

  tabs: {
    indicator: { boxShadow: "#ddd" },
  },
};

export default colors;
